import React from "react";
import { Button, Tooltip, Typography, Chip } from "@mui/material";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import VehicleGroupDataTableRowActions from "./VehicleGroupDataTableRowActions";
import { Link as RouterLink } from "react-router-dom";
import { getGridStringOperators } from "@mui/x-data-grid";
import { VEHICLE_GROUP_STATUS } from "../../services/Constants";
import TextField from "@mui/material/TextField";

const VehicleGroupStatusInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        {Object.entries(VEHICLE_GROUP_STATUS).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const getVehicleGroupsDataColumns = () => {
  const customFilterForGroupStatus = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: VehicleGroupStatusInput,
      InputComponentProps: { type: "string" },
    },
  ];

  // Column props reference available at - ota-portal_v2\node_modules\.pnpm\@mui+x-data-grid@5.15.2_rrttaqilrsb3aifveu7wjrwxnm\node_modules\@mui\x-data-grid\models\colDef\gridColDef.d.ts
  return [
    {
      field: "vehicleGroupName",
      headerName: "Group Name",
      width: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) =>
          operator.value !== "isEmpty" && operator.value !== "isNotEmpty",
      ),
      renderCell: (data) => {
        const { row: { vehicleGroupId = "" } = {} } = data;
        return (
          <Tooltip title={data?.value}>
            <Button
              size="medium"
              sx={{ justifyContent: "flex-start", textTransform: "none" }}
              component={RouterLink}
              to={`/groups/${vehicleGroupId}`}
            >
              <Typography
                noWrap
                sx={{
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {data?.value}
              </Typography>
            </Button>
          </Tooltip>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      flex: 0.75,
      editable: false,
      type: "singleSelect",
      sortable: false,
      disableColumnMenu: false,
      filterOperators: customFilterForGroupStatus,
      renderCell: ({ row }) => {
        const {
          status,
          processedCount = 0,
          totalCsvCount = 0,
          errorMessage,
        } = row;
        if (status === "IN_PROGRESS") {
          const pct =
            totalCsvCount > 0
              ? Math.round((processedCount / totalCsvCount) * 100)
              : 0;
          return (
            <Tooltip
              title={`Processing: ${processedCount} / ${totalCsvCount} vehicles (${pct}%)`}
            >
              <Chip label="IN PROGRESS" color="warning" size="small" />
            </Tooltip>
          );
        }
        if (status === "FAILED") {
          return (
            <Tooltip title={errorMessage || "Processing failed"}>
              <Chip label="FAILED" color="error" size="small" />
            </Tooltip>
          );
        }
        return null;
      },
    },

    {
      field: "vehicleCount",
      headerName: "Vehicles In Group",
      flex: 0.75,
      align: "right",
      headerAlign: "center",
      type: "number",
      disableColumnMenu: true,
      sortable: true,
      renderCell: (d) => {
        return d?.value ?? 0;
      },
    },

    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 0.75,
      type: "date",
      renderCell: (d) => <DateAndTimeGridCell value={d.value} />,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
    },
    {
      field: "updatedAt",
      headerName: "Updated Date",
      flex: 0.75,
      type: "date",
      renderCell: (d) => <DateAndTimeGridCell value={d.value} />,
    },
    {
      field: "updatedBy",
      headerName: "Updated By",
      flex: 1,
      renderCell: (d) => d?.value || "-",
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (d) => <VehicleGroupDataTableRowActions data={d} />,
      align: "center",
      headerAlign: "center",
    },
  ];
};

export { getVehicleGroupsDataColumns };
